import { createContext, useContext, useState } from 'react';
import { fetchWithToken } from '../../utils/fetch';
import { DASHBOARD_HTTPS_CODES } from '../../views/Dashboard/types';
import { Dashboard } from './types';
import Cookies from 'universal-cookie';

const dashboardContext = createContext<any>([]);

interface DashboardProviderProps {
	children: React.ReactNode;
}
export const useDashboardContext = () => {
	return useContext(dashboardContext);
};

// Sort Alphabetically (A-Z)
export const sortByReportName = (dashboards: Dashboard[]): Dashboard[] => {
	// .slice() to avoid mutating the original array
	return dashboards?.slice()?.sort((a, b) =>
		a?.report?.name?.localeCompare(b?.report?.name, undefined, {
			sensitivity: 'base', // ignore case & accents
		})
	);
};
export const DashboardProvider = ({ children }: DashboardProviderProps) => {
	const [dashboards, setDashboards] = useState<Dashboard[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const cookies = new Cookies();

	const getDashboards = async () => {
		setIsLoading(true);
		const res = await fetchWithToken('/dashboards');

		if (res?.status === DASHBOARD_HTTPS_CODES.INVALID_TOKEN) {
			cookies.remove('jwt_token');
			cookies.remove('name');
			cookies.remove('email');
		}

		if (res?.status === DASHBOARD_HTTPS_CODES.SUCCESS) {
			const sortedDashboards = sortByReportName(res?.data);
			setDashboards(sortedDashboards);
		}
		setIsLoading(false);

		return res;
	};

	return (
		<dashboardContext.Provider value={{ dashboards, isLoading, getDashboards }}>
			{children}
		</dashboardContext.Provider>
	);
};
